import React, { Fragment } from 'react';
import { get, post, put } from '../Services/http';
import { translate } from '../Services/translation';

export default function VatPicker(props) {
  const { vat } = props;
  const changeVat = async (includeVat) => {
    await post('/api/cart/toggleVat', includeVat);
    location.reload();
  };

  return (
    <div className="vat-picker">
      <button
        className={vat == 'False' ? 'caption-2 active' : 'caption-2'}
        onClick={() => changeVat('false')}
      >
        {translate('checkout.business')}
      </button>
      |
      <button
        className={vat == 'True' ? 'caption-2 active' : 'caption-2'}
        onClick={() => changeVat(true)}
      >
        {translate('checkout.private')}
      </button>
    </div>
  );
}
